import React from "react";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";

const Header = styled.header`
  color: white;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  background-color: rgba(20, 20, 20, 0.8);
  z-index: 10;
  box-shadow: 0px 1px 5px 2px rgba(0, 0, 0, 0.8);
`;

const List = styled.ul`
  display: flex;
`;

const Item = styled.li`
  width: 50px;
  height: 50px;
  text-align: center;
  border-bottom: 5px solid
    ${(props) => (props.current ? "#3498db" : "transparent")};
  transition: border-bottom 0.3s ease-in-out;
`;

const SLink = styled(Link)`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.h1`
  width: 150px;
  height: 50px;
  margin-right: 30px;
  background: url(${(props) => props.bgImage});
  background-size: cover;
  background-position: center center;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default withRouter(({ location: { pathname } }) => (
  <Header>
    <Logo bgImage={require("../assets/logo.PNG").default} />
    <List>
      <Item current={pathname === "/home"}>
        <SLink to="/">Movies</SLink>
      </Item>
      <Item current={pathname === "/tv"}>
        <SLink to="/tv">TV</SLink>
      </Item>
      <Item current={pathname === "/search"}>
        <SLink to="/search">Search</SLink>
      </Item>
    </List>
    <List>
      <Item current={pathname === "/profile"}>
        <SLink to="/profile">Profile</SLink>
      </Item>
    </List>
  </Header>
));
